const Button = ({
  children,
  href,
  onClick,
  variant = "solid",
  className = "",
  type = "button",
}) => {
  const base =
    " transition duration-300 text-center inline-block";

  const styles = {
    solid:
      "bg-primary text-black hover:text-black hover:bg-secondary px-6 py-3 font-medium rounded-2xl",
    whitesolid:
      "text-black border-2 border-white bg-white px-6 py-3 font-medium rounded-2xl",
    addsection:
      "border border-primary text-sm px-2 py-0 rounded-2xl bg-gradient-to-r from-purple-500 via-blue-300 to-white bg-clip-text text-transparent",
    addsubsection:
      "border border-gray-300 px-3 py-2 font-medium bg-background/50 rounded-3xl",
};

  const combined = `${base} ${styles[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={combined}>
        {children}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={combined} type={type}>
      {children}
    </button>
  );
};

export default Button;